function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  strokeWidth: ".5",
  strokeLinejoin: "bevel",
  fillRule: "evenodd",
  xmlns: "http://www.w3.org/2000/svg",
  overflow: "visible",
  viewBox: "0 0 48 48"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M4.54 44.08V17.36a3.92 3.92 0 013.92-3.93h5.1v-2.1C13.57 5.24 18.09 0 24 0s10.44 5.24 10.44 11.33v2.1h5.1a3.93 3.93 0 013.92 3.93v26.71A3.93 3.93 0 0139.54 48H8.46a3.93 3.93 0 01-3.92-3.92zm35.53 0V17.36c0-.3-.24-.54-.53-.54h-5.1v5.46a1.77 1.77 0 11-3.55 0v-5.46H17.11v5.46a1.77 1.77 0 01-3.54 0v-5.46h-5.1c-.3 0-.54.24-.54.54v26.71c0 .3.24.54.53.54h31.08c.3 0 .53-.24.53-.53zm-9.18-30.65v-2.1c0-4.47-3.25-7.79-6.89-7.79-3.64 0-6.89 3.32-6.89 7.79v2.1H30.9z"
})));